"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItem = exports.StyledOrderedList = exports.StyledUnorderedList = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setSize = (props) => {
    var _a, _b, _c, _d;
    return (0, styled_components_1.css) `
    font-size: ${(_a = props.size) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.typography) === null || _c === void 0 ? void 0 : _c.base) === null || _d === void 0 ? void 0 : _d.fontSize};
  `;
};
const setColor = (props) => {
    return props.color
        ? (0, styled_components_1.css) `
        color: ${props.color};
      `
        : undefined;
};
const setFontFamily = (props) => {
    var _a, _b, _c, _d;
    return (0, styled_components_1.css) `
    font-family: ${(_a = props.fontFamily) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.typography) === null || _c === void 0 ? void 0 : _c.base) === null || _d === void 0 ? void 0 : _d.fontFamily};
  `;
};
const setDecoration = (props) => {
    return props.decorated
        ? ''
        : (0, styled_components_1.css) `
        list-style-type: none;
      `;
};
const setInline = (props) => {
    return props.inline
        ? (0, styled_components_1.css) `
        display: inline;
      `
        : undefined;
};
const setItemMarker = (props) => props.itemMarkerUrl !== ''
    ? (0, styled_components_1.css) `
        list-style-image: url(${props.itemMarkerUrl});
      `
    : undefined;
const setLineHeight = (props) => props.lineHeight
    ? (0, styled_components_1.css) `
        line-height: ${props.lineHeight};
      `
    : undefined;
const setMargin = (props) => props.margin
    ? (0, styled_components_1.css) `
        margin: ${props.margin};
      `
    : undefined;
const setPadding = (props) => props.padding
    ? (0, styled_components_1.css) `
        padding: ${props.padding};
      `
    : undefined;
exports.StyledUnorderedList = styled_components_1.default.ul `
  ${setSize}
  ${setColor}
  ${setFontFamily}
  ${setMargin}
  ${setPadding}
`;
exports.StyledOrderedList = styled_components_1.default.ol `
  ${setSize}
  ${setColor}
  ${setFontFamily}
  ${setMargin}
  ${setPadding}
`;
exports.StyledListItem = styled_components_1.default.li `
  ${setDecoration}
  ${setInline}
  ${setItemMarker}
  ${setLineHeight}
`;
